import { GridAlignment, GridColDef } from "@mui/x-data-grid-pro";
import MessageModal from "../../../../../customComponents/MessageModal";
import { Button } from "../../../../../stories/Button/Button";
import { Label } from "../../../../../stories/Label/Label";
import { Title } from "../../../../../stories/Title/Title";
import { StyledDatagrid } from "../../../../../styles/DatagridStyles";
import { TABLE_ROW_HEIGHT } from "../../../../../styles/Variables";
import {
  EMPTY_STRING,
  ROWS_PER_PAGE,
  emptyFunc,
  emptyMessage,
} from "../../../../../utils/constants";
import { TableHeaderProps } from "../../../../../utils/types";
import LoadingModal from "../../../../pages/LoadingModal";
import useUrlParams from "../../../../../customHooks/useUrlParams";
import useLoggedInUserDetails from "../../../../../customHooks/useLoggedInUserDetails";
import { useContext, useState } from "react";
import useAssetTableJson from "../../../../../json/useAssetTableJson";
import { selectedMoveItem } from "./Table";
import Close from "../../../../../images/Close.svg";
import NoData from "../../../../../images/NoData.svg";
import { useMutation } from "@apollo/client";
import { Operation, empType } from "../../../../../utils/Enum.types";
import {
  AtsStckItemDetailsOrderField,
  ItemDetailsQueryType,
  MoveItemDetailsResult,
  MoveItemDetailsVar,
} from "../../masters/items/queries/types";
import { MoveItemDetails } from "../../masters/items/queries/mutations";
import { AppContext } from "../../../../../context/context";
import useLabels from "../../../../../customHooks/useLabels";
import CompaniesAutocomplete from "../../../customer/companies/CompaniesAutocomplete";
import { payloadTypes } from "../../../../../context/reducer";
import SubsidiarySelect from "../../../../../customComponents/SubsidiarySelect";
import SiteSelect from "../../../../../customComponents/SiteSelect";
import { GetItemsDetails } from "../../masters/items/queries/queries";
import { OrderDirection } from "../../../../../utils/commonQueryTypes";

interface Props {
  selectedMoveItems: selectedMoveItem[];
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
  setSelectedMoveItems: React.Dispatch<
    React.SetStateAction<selectedMoveItem[]>
  >;
}

const MoveItemDetailsList = ({
  selectedMoveItems,
  setModalFlag,
  setSelectedMoveItems,
}: Props) => {
  const { company_id, customer_id, siteID, sub_id, junctionID, item_id } =
    useUrlParams();
  const { user_details } = useLoggedInUserDetails();
  const { MoveItemDetailsList } = useAssetTableJson();
  const { state, dispatch } = useContext(AppContext);
  const { subsidiaryLabel, subsidiarySiteLabel, companyLabel, itemLabel } =
    useLabels();
  const [viewModal, setViewModal] = useState(false);

  const [message, setMessage] = useState(emptyMessage);

  const [moveItemDetails, { loading }] = useMutation<
    MoveItemDetailsResult,
    MoveItemDetailsVar
  >(MoveItemDetails, {
    onError: (err) => {
      setMessage({
        flag: true,
        message: (err as Error).message,
        operation: Operation.NONE,
      });
    },
  });

  const dynamicHeaders: TableHeaderProps[] = MoveItemDetailsList.List.map(
    (header) => ({
      headerName: header.headerName,
      field: header.field,
      headerAlign: header.headerAlign as GridAlignment,
      align: header.align as GridAlignment,
      flex: header.flex,
      hideable: header.hideable,
      cellClassName: header.cellClassName,
   
    })
  );
  const columns: GridColDef[] = [...dynamicHeaders];

  const handleClear = () => {
    dispatch({
      type: payloadTypes.SET_COMPANY_ID,
      payload: {
        companyId: 0,
      },
    });
    dispatch({
      type: payloadTypes.SET_SUB_ID,
      payload: {
        subsidiaryId: 0,
      },
    });
    dispatch({
      type: payloadTypes.SET_SUB_SITE_ID,
      payload: {
        subSiteId: 0,
      },
    });
  };

  const handleClose = () => {
    setSelectedMoveItems([]);
    setMessage(emptyMessage);
    setModalFlag(false);
    handleClear();
  };

  const HandleSubmit = async () => {
    const input = selectedMoveItems.map((item) => ({
      curCompanyID: state.companyId
        ? Number(state.companyId)
        : company_id
        ? company_id
        : 0,
      curJunctionID: 0,
      curSiteID: state.subSiteId
        ? Number(state.subSiteId)
        : siteID
        ? siteID
        : 0,
      curSubsidiaryID: state.subsidiaryId
        ? Number(state.subsidiaryId)
        : sub_id
        ? sub_id
        : 0,
      itemDetailsID: item.itemDetailId,
    }));

    if (customer_id) {
      moveItemDetails({
        variables: {
          customerID: customer_id,
          user_details,
          input,
        },
        refetchQueries: [
          {
            query: GetItemsDetails,
            variables: {
              customerID: customer_id ? customer_id : 0,
              companyID: company_id
                ? company_id
                : state.companyId
                ? state.companyId
                : 0,
              subsidiaryID: sub_id
                ? sub_id
                : state.subsidiaryId
                ? state.subsidiaryId
                : 0,
              junctionID: junctionID
                ? junctionID
                : state.junctionID
                ? state.junctionID
                : 0,
              siteID: siteID ? siteID : state.subSiteId ? state.subSiteId : 0,
              input: {
                query_type: ItemDetailsQueryType.DETAILS_BY_ITEM_ID,
                stckCategoryID: 0,
                stckGroupID: 0,
                stckManufacturerID: 0,
                stckUomID: 0,
                stckSubCategoryID: 0,
                itemID: state.itmId ? state.itmId : item_id ? item_id : 0,
                ldgrID: 0,
                poleNum: 0,
                empID: user_details.id!,
              },
              after: null,
              first: ROWS_PER_PAGE,
              name: EMPTY_STRING,
              orderBy: {
                direction: OrderDirection.ASC,
                field: AtsStckItemDetailsOrderField.CREATED_AT,
              },
            },
          },
        ],
      }).then(({ data }) => {
        if (data && data.MoveItemDetails) {
          setMessage({
            flag: true,
            message: `Move ${itemLabel} Details Successfully`,
            operation: Operation.CREATE,
          });
        }
      });
    }
  };

  return (
    <>
      <div className="assign-supplier">
        <div className="assign-supplier__title">
          <Title>Move {itemLabel} Details </Title>
          <img
            src={Close}
            alt=""
            onClick={() => {
              setModalFlag(false);
              handleClear();
            }}
          />
        </div>

        <div>
          {state.empSubType === empType.SYS_ADMIN && (
            <>
              <div className="label-grid">
                <Label>{companyLabel}</Label>
                <CompaniesAutocomplete
                  onChange={(newValue) => {
                    if (newValue) {
                      dispatch({
                        type: payloadTypes.SET_COMPANY_ID,
                        payload: {
                          companyId: newValue.node.id,
                        },
                      });
                    } else {
                      dispatch({
                        type: payloadTypes.SET_COMPANY_ID,
                        payload: {
                          companyId: 0,
                        },
                      });
                      dispatch({
                        type: payloadTypes.SET_SUB_ID,
                        payload: {
                          subsidiaryId: 0,
                        },
                      });
                      dispatch({
                        type: payloadTypes.SET_SUB_SITE_ID,
                        payload: {
                          subSiteId: 0,
                        },
                      });
                    }
                  }}
                  onKeyDown={emptyFunc}
                  value={
                    state.companyId
                      ? state.companyId
                      : company_id
                      ? company_id
                      : 0
                  }
                  label={""}
                />
              </div>
              <div className="label-grid">
                <Label>{subsidiaryLabel}</Label>
                <SubsidiarySelect
                  onChange={(newValue) => {
                    if (newValue) {
                      dispatch({
                        type: payloadTypes.SET_SUB_ID,
                        payload: {
                          subsidiaryId: newValue.node.id,
                        },
                      });
                    } else {
                      dispatch({
                        type: payloadTypes.SET_SUB_ID,
                        payload: {
                          subsidiaryId: 0,
                        },
                      });
                      dispatch({
                        type: payloadTypes.SET_SUB_SITE_ID,
                        payload: {
                          subSiteId: 0,
                        },
                      });
                    }
                  }}
                  onKeyDown={emptyFunc}
                  companyID={
                    state.companyId
                      ? state.companyId
                      : company_id
                      ? company_id
                      : 0
                  }
                  value={
                    state.subsidiaryId
                      ? state.subsidiaryId
                      : sub_id
                      ? sub_id
                      : 0
                  }
                  label={""}
                />
              </div>
              <div className="label-grid">
                <Label>{subsidiarySiteLabel}</Label>
                <SiteSelect
                  onChange={(newValue) => {
                    if (newValue) {
                      dispatch({
                        type: payloadTypes.SET_SUB_SITE_ID,
                        payload: {
                          subSiteId: newValue.value,
                        },
                      });
                    } else {
                      dispatch({
                        type: payloadTypes.SET_SUB_SITE_ID,
                        payload: {
                          subSiteId: 0,
                        },
                      });
                    }
                  }}
                  companyId={
                    state.companyId
                      ? state.companyId
                      : company_id
                      ? company_id
                      : 0
                  }
                  subsidiaryId={
                    state.subsidiaryId
                      ? state.subsidiaryId
                      : sub_id
                      ? sub_id
                      : 0
                  }
                  onKeyDown={emptyFunc}
                  value={
                    state.subSiteId ? state.subSiteId : siteID ? siteID : 0
                  }
                  label={""}
                />
              </div>
            </>
          )}
        </div>

        <div className="assign-supplier__tableblock--item">
          <StyledDatagrid
            columns={columns}
            rows={selectedMoveItems}
            rowHeight={TABLE_ROW_HEIGHT}
            // columnVisibilityModel={columnVisibilityModel}
            // onColumnVisibilityModelChange={handleColumnVisibilityChange}
            // initialState={{
            //   columns: {
            //     columnVisibilityModel: columnVisibilityModel,
            //   },
            // }}
            disableRowSelectionOnClick
            hideFooter
          />
        </div>

        <div className="row g-0">
          <div className="col">
            <Button mode="save" onClick={HandleSubmit} />
            <Button
              mode="cancel"
              onClick={() => {
                setModalFlag(false);
                handleClear();
              }}
            />
          </div>
          <div className="col-4 flex-end">
            <div className="overall-total-count">
              Selected {itemLabel} Count<b>{selectedMoveItems.length}</b>
            </div>
          </div>
        </div>
      </div>

      <MessageModal
        handleClose={handleClose}
        modalFlag={message.flag}
        operation={message.operation}
        value={message.message}
      />
      <LoadingModal flag={loading} />
    </>
  );
};

export default MoveItemDetailsList;
